import { render, staticRenderFns } from "./immediate-action-view.vue?vue&type=template&id=2ae4dd00&"
import script from "./immediate-action-view.vue?vue&type=script&lang=js&"
export * from "./immediate-action-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports